import type { ReactNode } from "react";
import { useTranslate } from "ra-core";

import { ListEmptyState } from "../design/ListStates";

/**
 * Almikia Epic E7 (TASK-094): the Dirección panel's 3 prepared, designed
 * empty-state slots -- "Necesitan tu VoBo" (E6), "Operaciones por semáforo"
 * (E4-E5) and "Cobranza" (E6) -- for the data the mockup (B-direccion) shows
 * but that does not exist yet. Never an invented count (mirrors
 * `LiderLeadSignalsPanel.tsx`'s "Operaciones con documentos pendientes"
 * slot). `showVoBoSlot` is `false` for a lead_manager: VoBo is direccion's
 * own slot (ticket ASSUMPTION).
 */

const SectionShell = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <div className="flex flex-col gap-3">
    <h2 className="text-xl font-semibold text-muted-foreground">{title}</h2>
    {children}
  </div>
);

export interface PreparedSlotsProps {
  /** `false` for a lead_manager -- the VoBo inbox is direccion's own slot. */
  showVoBoSlot: boolean;
}

export function PreparedSlots({ showVoBoSlot }: PreparedSlotsProps) {
  const translate = useTranslate();

  return (
    <div className="flex flex-col gap-6">
      {showVoBoSlot ? (
        <SectionShell title={translate("crm.dashboard.direccion.vobo_title")}>
          <ListEmptyState
            title={translate("crm.dashboard.direccion.vobo_empty_title")}
            description={translate(
              "crm.dashboard.direccion.vobo_empty_description",
            )}
          />
        </SectionShell>
      ) : null}

      <SectionShell
        title={translate("crm.dashboard.direccion.operations_title")}
      >
        <ListEmptyState
          title={translate("crm.dashboard.direccion.operations_empty_title")}
          description={translate(
            "crm.dashboard.direccion.operations_empty_description",
          )}
        />
      </SectionShell>

      <SectionShell
        title={translate("crm.dashboard.direccion.collections_title")}
      >
        <ListEmptyState
          title={translate("crm.dashboard.direccion.collections_empty_title")}
          description={translate(
            "crm.dashboard.direccion.collections_empty_description",
          )}
        />
      </SectionShell>
    </div>
  );
}
